// Widget API endpoints configuration
export const WIDGET_ENDPOINTS = {
    GET_ALL: '/widgets',
    CREATE: '/widgets/create',
    GET_BY_ID: (id: string) => `/widgets/${id}`,
    UPDATE: (id: string) => `/widgets/${id}`,
    DELETE: (id: string) => `/widgets/${id}`,
    REGENERATE_SECRET: (id: string) => `/widgets/${id}/regenerate-secret`,
    GET_BY_CHATBOT_ID: (chatbotId: string) => `/widgets/chatbot/${chatbotId}`,
} as const;

// Widget validation helpers
export const validateWidgetName = (name: string): boolean => {
    return name.trim().length >= 1 && name.trim().length <= 100;
};

export const validateWebhookUrl = (url: string): boolean => {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    } catch {
        return false;
    }
};

export const validateAllowedOrigins = (origins: string[]): boolean => {
    if (!origins || origins.length === 0) return true; // Empty array is valid (means allow all)
    
    return origins.every(origin => {
        if (origin === '*') return true; // Wildcard is valid
        
        try {
            // Check if it's a valid URL or domain pattern
            if (origin.startsWith('http://') || origin.startsWith('https://')) {
                new URL(origin);
                return true;
            } else {
                // Domain pattern validation (e.g., example.com, *.example.com)
                const domainRegex = /^(\*\.)?[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                return domainRegex.test(origin);
            }
        } catch {
            return false;
        }
    });
};

export const validateHexColor = (color: string): boolean => {
    const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    return hexColorRegex.test(color);
};

// Widget status helpers
export const WIDGET_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
} as const;

export type WidgetStatus = typeof WIDGET_STATUS[keyof typeof WIDGET_STATUS];
